"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _pragma = require("../../../pragma");

var React = _interopRequireWildcard(require("react"));

var _victory = require("victory");

var _reactFela = require("react-fela");

var _util = require("../../../util");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const getAutoVariant = (threshold, currValue) => {
  const hasThreshold = typeof threshold === 'number';
  const hasCurrValue = typeof currValue === 'number';

  if (hasThreshold && hasCurrValue) {
    const isAboveThreshold = currValue >= threshold;
    return isAboveThreshold ? 'positive' : 'negative';
  }

  return 'indeterminate';
};
/**
 * LineGraph — Line graphs can be used to show how something changes over time.
 *
 * The LineGraph component displays a themed version of a line graph, built
 * on top of the `victory` library.
 *
 * It accepts a `data` prop, which is passed to the inner `VictoryLine`
 * component, and it used to render the graph data.
 *
 * It also accepts a `threshold` prop, which represents the number corresponding
 * to the Y axis value that the threshold should be rendered at. When the
 * variant is set to 'auto', the LineGraph will compare the threshold to the
 * last data entry's Y value to determine to appearance of the graph.
 *
 * The LineGraph component is also lazy-loaded via `React.lazy` and `Suspense`,
 * when imported as a named import via `app/components/base`, or from
 * `app/components/base/LineGraph`. If this code-splitting is undesirable,
 * it can also be imported directly via `app/components/base/LineGraph/LineGraph`.
 *
 * For more details, refer to the Victory docs at:
 * https://formidable.com/open-source/victory/docs
 */


const LineGraph = ({
  data = [{
    x: 0,
    y: 0
  }],
  responsive = false,
  threshold,
  variant = 'auto',
  animate = false,
  ...otherProps
}) => {
  const fela = (0, _reactFela.useFela)();
  const theme = fela.theme;
  const firstItem = data[0];
  const lastItem = data[data.length - 1];
  const depositData = [{ ...firstItem,
    y: threshold
  }, { ...lastItem,
    y: threshold
  }];
  const hasThreshold = typeof threshold === 'number';
  const autoVariant = getAutoVariant(threshold, lastItem.y);
  const renderedVariant = variant === 'auto' ? autoVariant : variant;
  const variantTheme = theme.lineGraphs[renderedVariant];
  const variantColor = (0, _util.color)(theme, variantTheme.color);
  const variantDepositColor = (0, _util.color)(theme, variantTheme.colorDeposit);
  return (0, _pragma.createFelaElement)(_victory.VictoryGroup, _extends({
    animate: animate ? {
      onLoad: {
        duration: 1
      },
      duration: 500
    } : false,
    containerComponent: (0, _pragma.createFelaElement)(_victory.VictoryContainer, {
      responsive: responsive
    }),
    padding: 0,
    theme: variantTheme
  }, otherProps), hasThreshold && (0, _pragma.createFelaElement)(_victory.VictoryLine, {
    animate: false,
    data: depositData,
    style: {
      data: {
        stroke: variantDepositColor,
        strokeDasharray: 2
      }
    }
  }), (0, _pragma.createFelaElement)(_victory.VictoryLine, {
    data: data,
    style: {
      data: {
        stroke: variantColor
      }
    }
  }));
};

LineGraph.displayName = 'LineGraph';
var _default = LineGraph;
exports.default = _default;
//# sourceMappingURL=LineGraph.js.map